import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2)
    },
    remitActions: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(1),
      marginBottom: theme.spacing(1),
      paddingRight: 0
    },
    container: {
      marginTop: theme.spacing(3)
    },
    divider: {
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(1)
    },
    datesFilter: {
      marginTop: theme.spacing(2)
    },
    description: {
      color: '#828282'
    },
    cardContent: {
      padding: 0,
      paddingBottom: '0 !important',
      justifyContent: 'space-between',
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    cardContentPadding: {
      padding: 16
    },
    dateFilterContainer: {
      marginRight: 16
    },
    buttonContainer: {
      marginTop: 16
    }
  })
